<template>
	<div class="contentTab">
<!--		:headers="headers"-->
<!--		isSettings-->

		<main-table
				v-if="bonusChargeFilter"
				page-title="Bonus/charge for employee"
				default-sort-by="id"
				:default-sort-desc="true"
				:uniqId="uniqId"
				:settings="getSettings"
				:flag="flag"
				:headers="headers"
				:filters-list="bonusChargeFilter"
				:list-items="bonusChargeList"
				:is-export="false"
				:is-create="isCreate()"
				:is-create-permissions="true"
				@updateEdit="onEdit"
				@updateChangeSort="onFilter"
				@updateRefreshFilters="onFilter"
				@updateSearch="onFilter"
				@updateEvent="onEvent"
				@updateSettings="onSettingsOpen"
				@updateExport="onExport"
				@updateFile="onPreview"
				@updateClickButton="onClickButton"
		></main-table>
		<bonus-charge-create
				v-if="isBonusChargeCreate"
				:itemId="itemId"
				@updateClose="onClose"
		></bonus-charge-create>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('bonus-charge')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<preview-document v-if="previewLink" ></preview-document>
		<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link"/>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components async
const BonusChargeCreate = () => import("@/components/Accounting/BonusCharge/BonusChargeCreate/BonusChargeCreate");
// shared
import PreviewDocument from "@/shared/PreviewDocument/PreviewDocument";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PERMISSIONS, TAB } from "@/constants/constants";
import previewMixins from "@/mixins/previewMixins";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import { TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import PreviewDoc from "@/modules/invoices/preview.vue";
import { getAppUrl } from "@/services";

export default {
	name: "AccountTabBonusCharge",
	mixins: [ settingsMixins, removeMixins, previewMixins ],
	components: { PreviewDoc, DialogRemove, PreviewDocument, BonusChargeCreate },
	props: {
		user: Object,
	},
	computed: {
		...mapGetters([
			"bonusChargeList", "bonusChargeFilter", "permissions", "permissionsDefault"
		]),
	},
	data: () => ({
		flag: TAB.ACCOUNT_TAB_BONUS_CHARGE,

		isBonusChargeCreate: false,
		removeId: null,
		isPreloader: false,
		link: false,

		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
		nameComponent: null,
		role: null,
		filterModList: null,
	}),
	methods: {
		...mapActions([
			"getBonusCharge",
			"onBonusChargeFilter",
			"onBonusChargeEdit",
			"onExportLink",
			"onRemoveBonusCharge"
		]),
		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_BONUS_CHARGE, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},
		onClickButton(args) {
			
			console.log('%c [  args  ] ', 'color:#bada55', typeof args, args );
			const { key, item } = args;

			this.activeItem = item;
			if (key === "delete") {
				const list = this.permissionsDefault;
				const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_BONUS_CHARGE, PERMISSIONS.DELETE ];
				const perm = getPermissionsMod({ list, path });
				if (perm) {
					const title = TITLE.REMOVE_PAYMENT;
					const text = TEXT.REMOVE_PAYMENT;
					this.onRemoveDialog({ title, text });
				}
			}

			if (key === "edit") {
				const list = this.permissionsDefault;
				const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_BONUS_CHARGE, PERMISSIONS.EDIT ];
				const perm = getPermissionsMod({ list, path });
				if (perm) {
					this.itemId = item.id;
					this.isBonusChargeCreate = true;
				}
			}

			if (key === "view") {
				this.onPreview(item.file);
			}
		},

		onPreview(file) {
			this.link = file.includes('data:') ? file : getAppUrl + file;
		},
		clearLink() {
			this.link = null;
		},

		async onRemove() {
			this.isPreloader = true;
			await this.onRemoveBonusCharge(this.activeItem);
			this.onCloseRemove();
			// await this.getBonusCharge();
			this.onFilter();
			this.isPreloader = false;
		},

		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},

		onCloseRemove() {
			this.isDialogRemove = false;
		},

		async onEdit({ line }) {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_BONUS_CHARGE, PERMISSIONS.EDIT ];
			const perm = getPermissionsMod({ list, path });
			if (perm) {
				const { id } = line;
				this.itemId = id;
				this.isBonusChargeCreate = true;
			}
		},

		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'bonus-charge' });
		},

		onClose() {
			this.isBonusChargeCreate = false;
			this.onFilter();
		},

		onEvent({ flag }) {
			if (flag === "create") {
				this.itemId = null;
				this.isBonusChargeCreate = true;
			}
		},
		async onFilter(args) {
			if (args && args.filterModList) {
				this.filterModList = args.filterModList;
				await this.onBonusChargeFilter(this.filterModList);
			} else if (this.filterModList) {
				await this.onBonusChargeFilter(this.filterModList);
			} else {
				await this.onBonusChargeFilter({});
			}
		}
	},
	async created() {

		await this.getBonusCharge();

		if (this.user) {
			this.role = this.user.role; // Присваиваем `role` при инициализации
		}

	},
};
</script>
